module.exports = __webpack_public_path__ + "static/media/buryTheCards_lv.f11daf83.svg";